import React from "react";
import Slider from "react-slick";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import NavigateNext from "@material-ui/icons/NavigateNext";
import styles from "./styles";
import VideoCard from "./VideoCard";

export const VideoSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const classes = styles();
  return (
    <div className={classes.sliderContainer}>
      {/* <Slider {...settings} className={classes.sliderSlick}> */}
      <div>
        <VideoCard
          urlVideo="https://vimeo.com/547278397"
          titleMain="Cero trámites"
          description="Optimiza tu Plan de Medicina Prepagada con Cero Tramites de Saludsa. Accede a la mejor atención médica en un solo lugar, de forma rápida y fácil, pagando valores mínimos en consultas, exámenes, procedimientos y más."
        />
      </div>
      <div>
        <VideoCard
          urlVideo="https://vimeo.com/547278679"
          titleMain="Reembolso online"
          description="Conoce sobre nuestro nuevo y mejorado proceso de reembolsos, en donde de forma rápida y sencilla podrás solicitar el reembolso de tus atenciones médicas desde la comodidad de tu hogar a través de tu App Saludsa o Portal Clientes."
        />
      </div>
      <div>
        <VideoCard
          urlVideo="https://www.youtube.com/watch?v=X0FRIjj5c0A"
          titleMain="Oficina virtual"
          description="Una nueva manera de estar conectados
Agenda una video llamada con nuestros ejecutivos para que atiendan todos tus requerimientos"
        />
      </div>
      <div>
        <VideoCard
          urlVideo="https://vimeo.com/547278528"
          titleMain="Evaluador de síntomas"
          description="Conoce más sobre el nuevo Evaluador de Síntomas, una herramienta de pre diagnóstico precisa y de última tecnología, donde podrás evaluar tus síntomas y recibir opciones de atención médica inmediata. "
        />
      </div>
      {/* </Slider> */}
    </div>
  );
};
